

import { usePermission } from 'src/hooks/use-permission';

import { RoleBasedGuard } from './role-based-guard';

export function PermissionRoute({ children, permission }) {
    const { hasPermission } = usePermission();
    
    if (!hasPermission(permission)) {
        return (
            <RoleBasedGuard hasContent>
                {null}
            </RoleBasedGuard>
        );
    }

    return children;
} 